// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f415f574","455":"649ea934","977":"0f871d0e"}[chunkId] + ".chunk.js";
};